import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteShell from "@/components/site/SiteShell";
import Page from "@/pages/Page";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminShell from "@/pages/admin/AdminShell";
import Dashboard from "@/pages/admin/Dashboard";
import PagesEditor from "@/pages/admin/PagesEditor";
import GlobalEditor from "@/pages/admin/GlobalEditor";
import MenusManager from "@/pages/admin/MenusManager";
import BlogManager from "@/pages/admin/BlogManager";
import LeadsInbox from "@/pages/admin/LeadsInbox";
import AiUpdater from "@/pages/admin/AiUpdater";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteShell env="live" />}>
            <Route path="/" element={<Page />} />
            <Route path="/journal/:postSlug" element={<BlogPost />} />
            <Route path="/:slug" element={<Page />} />
          </Route>
          <Route path="/staging" element={<SiteShell env="staging" />}>
            <Route index element={<Page />} />
            <Route path="journal/:postSlug" element={<BlogPost />} />
            <Route path=":slug" element={<Page />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminShell />}>
            <Route index element={<Dashboard />} />
            <Route path="pages" element={<PagesEditor />} />
            <Route path="global" element={<GlobalEditor />} />
            <Route path="menus" element={<MenusManager />} />
            <Route path="blog" element={<BlogManager />} />
            <Route path="leads" element={<LeadsInbox />} />
            <Route path="ai" element={<AiUpdater />} />
          </Route>
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
